import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';

import authReducer from './authSlice';
import configReducer from './configSlice';
import globalUIReducer from './globalUISlice';
import { sageAdminApi } from './sageAdminApi';
import { sageCameraApi } from './sageCameraApi';
import { sageCareServiceApi } from './sageCareServiceApi';
import { sageDeviceAuditApi } from './sageDeviceAuditApi';
import { sageGamificationApi } from './sageGamificationApi';
import { sageIdentityProviderSyncApi } from './sageIdentityProviderSyncApi';
import { sageInsightsEngineApi } from './sageInsightsEngineApi';
import { sageLocationQueryApi } from './sageLocationQueryApi';
import { sageMessageOrchestrationApi } from './sageMessageOrchestrationApi';
import { sageStaffCommsApi } from './sageStaffCommsApi';
import { sageTabularRecordServiceApi } from './sageTabularRecordServiceApi';
import trainingReducer from './trainingSlice';

// Create the root reducer separately so we can extract the RootState type
const rootReducer = combineReducers({
    [sageAdminApi.reducerPath]: sageAdminApi.reducer,
    [sageCameraApi.reducerPath]: sageCameraApi.reducer,
    [sageCareServiceApi.reducerPath]: sageCareServiceApi.reducer,
    [sageDeviceAuditApi.reducerPath]: sageDeviceAuditApi.reducer,
    [sageGamificationApi.reducerPath]: sageGamificationApi.reducer,
    [sageIdentityProviderSyncApi.reducerPath]: sageIdentityProviderSyncApi.reducer,
    [sageInsightsEngineApi.reducerPath]: sageInsightsEngineApi.reducer,
    [sageLocationQueryApi.reducerPath]: sageLocationQueryApi.reducer,
    [sageMessageOrchestrationApi.reducerPath]: sageMessageOrchestrationApi.reducer,
    [sageStaffCommsApi.reducerPath]: sageStaffCommsApi.reducer,
    [sageTabularRecordServiceApi.reducerPath]: sageTabularRecordServiceApi.reducer,
    appConfig: configReducer,
    authConfig: authReducer,
    globalUI: globalUIReducer,
    training: trainingReducer,
});

export const setupStore = (preloadedState?: Partial<RootState>) => {
    return configureStore({
        reducer: rootReducer,
        preloadedState,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware().concat(
                sageAdminApi.middleware,
                sageCameraApi.middleware,
                sageCareServiceApi.middleware,
                sageDeviceAuditApi.middleware,
                sageGamificationApi.middleware,
                sageIdentityProviderSyncApi.middleware,
                sageInsightsEngineApi.middleware,
                sageLocationQueryApi.middleware,
                sageMessageOrchestrationApi.middleware,
                sageStaffCommsApi.middleware,
                sageTabularRecordServiceApi.middleware
            ),
    });
};

export const store = setupStore();

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
